import { useState } from "react";
import SectionSetting from "components/common/SectionSetting";
import AlarmTable from "./AlarmTable";

const Alarm = (props) => {
  const { wellId, assetId, loadingIconActions } = props;
  // AV-D3: functional search + severity filter (was a dead control before).
  const [search, setSearch] = useState("");
  const [severityFilter, setSeverityFilter] = useState("ALL");
  // AV-D3: hide already-acknowledged alarms.
  const [hideAcked, setHideAcked] = useState(false);

  return (
    <div className="cards-container h-100">
      <div className="cards-header d-flex flex-row justify-content-between align-items-center">
        <span className="header-title">Alarm</span>
        <div className="header-menu-container d-flex flex-row align-items-center">
          <div className="form-container me-2">
            <form
              className="app-search d-none d-lg-block"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="d-flex flex-row">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search tag / well / type..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <div className="search-icon">
                  <i className="bi bi-search"></i>
                </div>
              </div>
            </form>
          </div>
          <select
            className="form-select form-select-sm me-2"
            style={{ width: "auto" }}
            value={severityFilter}
            onChange={(e) => setSeverityFilter(e.target.value)}
            aria-label="Filter by severity"
          >
            <option value="ALL">All severities</option>
            <option value="Critical">Critical</option>
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
          <div className="form-check form-switch me-2 d-flex align-items-center">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="alarmHideAcked"
              checked={hideAcked}
              onChange={(e) => setHideAcked(e.target.checked)}
            />
            <label
              className="form-check-label ms-1"
              htmlFor="alarmHideAcked"
              style={{ whiteSpace: "nowrap" }}
            >
              Hide ack&apos;d
            </label>
          </div>
          <div className="cards-setting-btn">
            <SectionSetting disable />
          </div>
        </div>
      </div>
      <div className="cards-content">
        <div className="table-container overflow-auto hide-scrollbar">
          <AlarmTable
            wellId={wellId}
            assetId={assetId}
            loadingIconActions={loadingIconActions}
            search={search}
            severityFilter={severityFilter}
            hideAcked={hideAcked}
          />
        </div>
      </div>
    </div>
  );
};
export default Alarm;
